<template>
  <div>
    <div class="request-card" :class="[
        { 'request-card-declined': accept_state === 'DECLINED' },
        { 'request-card-accepted': accept_state === 'ACCEPTED' },
      ]"
    >
    <!-- Avatar -->
      <div class="image-content-trade">
        <router-link :to="`/s-app/profile-page/${request.sUser.id}`">
          <SUserAvatar
            :myUser="request.sUser"
            size="x-small"
            :isProfileAvatar="true"
          />
        </router-link>
      </div>
      <!-- Username + City -->
      <div class="user-info">
        <router-link :to="`/s-app/profile-page/${request.sUser.id}`">
          <span class="user-name-info">@{{ request.sUser.username }}</span>
        </router-link>
        <span v-if="request.sUser.city" class="user-city-info">{{ request.sUser.city }}</span>
      </div>
      <!-- Payment -->
      <div class="user-payment" :class="[
          { 'md-xsmall-size-35': accept_state === 'WAITING_ACCEPT' },
          { 'md-xsmall-size-35': accept_state !== 'WAITING_ACCEPT' },
        ]"
      >
        <div class="user-payment-wrapper">
          <p v-if="request.payWith === 'money'" class="payments-cash">
            <span class="payments-cash-username">{{ request.sUser.username }} chose to pay with</span> <span class="value-trade">${{ cash }}</span>
          </p>

          <p v-if="request.payWith !== 'money'" class="payments-points">
            <span class="payments-points-username">{{ request.sUser.username }} chose to pay with</span>
            <span class="value-trade">
              {{points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              <img
                src="/img/Polygon_7.svg"
                alt="Swampum"
                width="12px"
                height="12px"
                class="poylgon-img"
              />
            </span>
          </p>
        </div>
      </div>
      <!-- Actions -->
      <div class="request-actions">
        <div class="item-accept-reject-request-item-detail" v-if="accept_state === 'WAITING_ACCEPT'">
          <md-button
            class="md-icon-button md-raised md-fab md-primary btn-size"
            @click="openResponsabilityModal('accept', request.id)"
            data-cy="requestAcceptButton"
            :data-cy-itemtitle="item.title"
          >
            <md-icon>done</md-icon>
          </md-button>
          <md-button
            class="md-icon-button md-raised md-fab md-primary btn-size"
            @click="decline()"
            data-cy="requestDeclineButton"
            :data-cy-itemtitle="item.title"
          >
            <md-icon>close</md-icon>
          </md-button>
        </div>
        <div class="request-result" v-if="accept_state === 'DECLINED'">
          <md-icon class="request-declined-icon">close</md-icon>
          <div class="request-result-content">
            <span class="request-result-text">
              Declined {{getTimeAgo(request.updatedAt)}}
            </span>
          </div>
        </div>
        <div class="request-result" v-if="accept_state === 'ACCEPTED'">
          <md-icon class="request-accepted-icon">done</md-icon>
          <div class="request-result-content">
            <span class="request-result-text">
              Accepted {{getTimeAgo(request.updatedAt)}}
            </span>
          </div>
        </div>
        <div v-if="accept_state === 'PROCESSING'">
          <LoadingSpinner position="relative" />
        </div>
      </div>
    </div>

    <dropdown-menu
      id="drop-chat"
      v-model="show"
      :right="false"
      :hover="false"
      :hover_time="hoverTime"
      :closeOnClickOutside="false"
      transition="translate-fade-down"
    >
      <div class="chat-content">
        <md-button
          :md-ripple="false"
          md-elevation="0"
          class="md-icon-button dropdown-toggle menu-hamburguer menu-chat"
          data-cy="tbHamburgerHeader"
          @click="scrollChatMessage"
        >
          <md-icon class="icon-margin-request desktop-chat-icon" v-if="show"
            >arrow_drop_up</md-icon
          >
          <md-icon class="icon-margin-request desktop-chat-icon" v-if="!show"
            >arrow_drop_down</md-icon
          >
        </md-button>
      </div>

      <div slot="dropdown" class="my-drop-chat">
        <SCardChat
          :partner="request.sUser"
          :usrMessages="tradeMessages"
          :item="item"
          :isItemDetailContent="true"
          ref="cardChat"
        />
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import DropdownMenu from "@innologica/vue-dropdown-menu";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import SCardChat from "@/material-components/organisms/SCardChat.vue";
import itemType from "@/enum/item-type";
import requestSituation from "@/enum/request-situation";
export default {
  name: "SItemRequest",
  props: ["request", "points", "cash", "item"],
  mixins: [UserHelperVue, ItemHelperVue, ChatHelperVue],
  components: {
    LoadingSpinner,
    DropdownMenu,
    SCardChat,
    SUserAvatar,
  },
  data() {
    return {
      accept_state: "WAITING_ACCEPT",
      acceptNotification: "",
      declineNotification: "",
      show: false,
      hoverTime: 500,
    };
  },
  methods: {
    scrollChatMessage() {
      setTimeout(() => {
        this.$refs.cardChat.scrollToBottom();
      }, 100);
    },
    setRequestAsAccepted() {
      this.accept_state = "ACCEPTED";
    },
    setRequestAsRejected() {
      this.accept_state = "DECLINED";
    },
    openResponsabilityModal(action, requestId) {
      this.setItemInterested({ item: this.item, requestId: requestId });
      this.setModalTitle();
      setTimeout(() => {
        $(`#${action}`).modal("show");
      }, 501);
    },
    async decline() {
      this.accept_state = "PROCESSING";
      this.setNotification();
      let response = null;
      try {
        response = await this.declineItemRequest({ request: this.request });
        if (response === 200) {
          await this.postUserItemMessage({
            partner: this.request.sUserId,
            item: this.request.itemId,
            postMsg: this.declineNotification,
            newChat: true,
          });
          this.accept_state = "DECLINED";
        }
      } catch (error) {
        console.log(error);
      }
    },
    setNotification() {
      const type = this.item.type;
      if (typeof this.request === "object" && this.request.item) {
        if (type === itemType.GIVE || type === itemType.LEND) {
          this.acceptNotification = `Hi, I accepted your request for the item ${this.request.item.title}`;
          this.declineNotification = `Hi, I didn't accept your request for the item ${this.request.item.title}`;
        } else {
          this.acceptNotification = `Hi, I accepted your offer for the item ${this.request.item.title}`;
          this.declineNotification = `Hi, I didn't accept your offer for the item ${this.request.item.title}`;
        }
      }
    },
    setModalTitle() {
      if (this.item !== undefined) {
        let type = this.item.type;
        if (type === itemType.GIVE || type === itemType.LEND) {
          this.$emit("accept-request");
        } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
          this.$emit("accept-offer");
        }
      }
    },
    getTimeAgo(time) {
      const date = new Date(time);
      return "at " + date.toLocaleString('en-us', { dateStyle: 'short' });
    },
  },
  computed: {
    tradeMessages() {
      return this.userMessages.find((item) => {
        return item.key.id === this.item.id;
      });
    },
    getxxSmalWidthClass() {
      let w = $(window).width();
      return w <= 508 ? "md-xsmall-size-30" : "";
    },
    getTradeTypeText() {
      const type = this.item?.type ?? null;
      if (!type) return "";
      if (type === itemType.GIVE || type === itemType.LEND) {
        return "Request";
      } else {
        return "Offer";
      }
    },
  },
  mounted() {
    if (requestSituation.REJECTED === this.request.situation) {
      this.accept_state = "DECLINED";
    }

    if (requestSituation.ACCEPTED === this.request.situation) {
      this.accept_state = "ACCEPTED"
    }
  },
};
</script>

<style lang="scss" scoped>
.request-card-root {
  width: 100%;

  display: flex;
}
.request-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: white;
  box-sizing: border-box;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.image-content-trade {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-info {
  width: 45%;
  display: flex;
  flex-direction: column;
}

.user-name-info {
  width: 100%;
  word-break: break-word;
  font-weight: bold;
  font-size: 12px !important;
}

.user-city-info {
  font-weight: normal;
  font-size: 10px !important;
  opacity: 0.8;
}

.user-payment {
  width: 30%;
  display: flex;
  justify-content: center;
}

.user-payment-wrapper {
  width: 100%;
  text-align: center;
}

.payments-cash {
  width: 100%;
  margin: 0;
}

.payments-cash-username {
  display: none;
  visibility: visible;
}

.payments-points-username {
  display: none;
  visibility: visible;
}

.payments-points {
  margin: 0;
  display: none;
}

.request-actions {
  width: 55%;
}

.my-drop-chat {
  width: 100%;
}

.user-payment-info,
.user-payment-info-mobile {
  display: flex;
  flex-direction: column;
}
.user-payment-info-mobile {
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 1.25px;
  color: $black;

}
.user-name-info,
.user-city-info,
.user-payment-info {
  line-height: 20px;
  letter-spacing: 1.95px;
  color: $black;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}

.user-payment-info {
  font-size: 16px;
}

.payment-value {
  margin-top: 1.2rem;
  margin-left: -1.59rem;
}
.points-content {
}
.value-trade {
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  color: #000000;

  margin-left: 0.3rem;
}
.request-result {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 5px
}
.request-result-content {
  width: 100%;
  display: flex;
  align-items: center;
}

.request-declined-icon {
  color: $white !important;
  background: $danger;
  opacity: 0.8;
  border-radius: 50%;
  font-size: 12px !important;
}
.request-accepted-icon {
  color: $white !important;
  background: $primary;
  opacity: 0.8;
  border-radius: 50%;
  font-size: 12px !important;
}
.request-result-text {
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0.25px;
  font-size: 10px;
  color: $black;
  opacity: 0.6;
}
.request-card-declined,
.request-card-accepted {
  box-sizing: border-box;
  border-radius: 4px;
}
.request-card-declined {
  border: 3px solid #DD2803;
  background-color: #FCEAE6;
}
.request-card-accepted {
  border: 3px solid #05919B;
  background-color: #E6F4F5;
}
.poylgon-img {
  margin-bottom: 1rem;
}
.icon-margin-request {
  cursor: pointer;
}
</style>

<style lang="scss">
.item-accept-reject-request-item-detail {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  .md-button:first-child {
    width: 40px;
    height: 40px;
  }
  .md-button:first-child .md-ripple {
    background: $primary;
  }
  .md-button:last-child .md-ripple {
    background: $danger;
  }
  .md-button:last-child {
    width: 40px;
    height: 40px;
  }
  i {
    color: $white !important;
  }
  .request-result-declined .md-icon {
    color: $danger !important;
  }
}
.menu-chat {
  position: absolute;
  top: -55px;
  right: 10px;
}
.menu-chat i {
  font-size: 30px !important;
}
.desktop-chat-icon,
.user-name-info {
  font-size: 300px;
}
.texto {
  opacity: 0.7;
  margin-right: 3px;
}

@media screen and (min-width: 729px) and (max-width: 768px) {
  .texto {
    font-size: 14px !important;
  }
  .menu-chat {
    right: -5px;
  }
  .user-name-info {
    font-size: 18px !important;
  }
}
@media screen and (min-width: 663px) and (max-width: 728px) {
  .menu-chat {
    right: -5px;
    top: -55px;
  }
  .texto {
    font-size: 12px !important;
  }
  .user-name-info {
    font-size: 16px !important;
  }
  .user-city-info {
    font-size: 14px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 662px) {
  .texto {
    font-size: 10px !important;
  }
  .user-name-info {
    font-size: 14px !important;
  }
  .user-city-info {
    font-size: 12px !important;
  }
  .value-trade {
    font-size: 20px !important;
  }
  .item-accept-reject-request-item-detail {
    .md-button:first-child {
      width: 35px;
      height: 35px;
    }
    .md-button:last-child {
      width: 35px;
      height: 35px;
    }
  }
  .menu-chat {
    right: -10px;
    top: -55px;
  }
}
@media screen and (min-width: 499px) and (max-width: 600px) {
  .menu-chat {
    right: -12px;
    top: -55px;
  }
  .item-accept-reject-request-item-detail {
    .md-button:first-child {
      width: 30px;
      height: 30px;
    }
    .md-button:last-child {
      width: 30px;
      height: 30px;
    }
  }
  .user-name-info {
    font-size: 12px !important;
  }
  .user-city-info {
    font-size: 10px !important;
  }
  .value-trade {
    font-size: 20px !important;
  }
  .texto {
    font-size: 10px !important;
  }
  .user-payment-info {
    margin-right: -16px !important;
  }
  .request-result-text {
    font-size: 10px;
  }
}
@media screen and (max-width: 499px) {
  .menu-chat {
    right: -12px;
    top: -55px;
  }
  .item-accept-reject-request-item-detail {
    .md-button:first-child {
      width: 35px;
      height: 35px;
    }
    .md-button:last-child {
      width: 35px;
      height: 35px;
    }
  }
  .md-icon {
    font-size: 18px !important;
  }

  .user-name-info {
    font-size: 14px !important;
    margin-right: -25px !important;
  }
  .user-city-info {
    font-size: 10px !important;
    margin-right: -25px !important;
  }
  .value-trade {
    font-size: 18px !important;
  }
  .user-payment-info-mobile {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    margin-left: 0;
  }
}
@media screen and (max-width: 450px) {
  .request-card {
    margin: 0 !important;
    padding: 0 !important;
  }
  .item-accept-reject-request-item-detail {
    .md-button:first-child {
      width: 25px;
      height: 25px;
      margin-left: -10px;
    }
    .md-button:last-child {
      width: 25px;
      height: 25px;
      margin-left: -10px;
    }
  }
  .menu-chat {
    right: -25px;
    top: -45px;
  }
}

@media screen and (max-width: 960px) {
  .item-accept-reject-request-item-detail {
    justify-content: center;

    button:first-child {
      margin-right: 1.5rem;
    }
  }
  .menu-chat {
    position: relative;
    margin-top: 0.75rem !important;
    margin-right: 1rem !important;
  }
  .chat-content {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .request-result-content {
    padding-right: 0px !important;
    width: 100%;
  }
  .request-result-text {
    font-size: 12px;
  }
  .request-result {
    width: 30%;
  }
}

@media screen and (min-width: 961px) {
  .user-info {
    width: 30% !important
  }
  .user-payment {
    width: 50% !important;
  }
  .request-actions {
    width: 20% !important;
  }

  .payments-cash-username {
    display: inline !important;
  }

  .payments-points-username {
    display: inline !important;
  }

  .menu-chat {
    right: -15px;
    top: -40px;
  }
}
</style>
